export default "__VITE_ASSET__D4Rk59pu__"